import styled from "styled-components"
import {Row} from "react-bootstrap"

export const StyledRow = styled(Row)`
  margin-bottom: 15px;
`

export const FooterWrapper = styled.footer`
  padding: 30px 0;
  background-color: ${({theme}) => theme.colors.greys.white};
  display: flex;
  width: 100%;
  z-index: 0;
`

export const Copyright = styled.span`
  color: #BBB;
`

export const List = styled.ul`
  margin: 0 -10px;
  padding: 0;
  list-style: none;
  li {
    display: inline-block;
    padding: 0 10px;
  }
`
